import React from 'react';
import Modal from "components/Modal";
import TermsAndConditions from 'components/ModalTermsConditions/TermsAndConditions';
import { actionsType } from 'config/constants';
import PubSub from 'services/PubSub';
import { modalTermsConditionBlock } from 'config';
import { termsConditionsText } from 'config/translate/variables';
import style from './style.scss'; //NOSONAR

const ModalTermsConditions = () => {

    return (
        <Modal  customClass={'modal-terms-conditions ' + (termsConditionsText?.onlyParagraph ? ' onlyParagraf' : '')} actionOpen={actionsType.MODAL.TERMS_AND_CONDITIONS_OPEN} actionClose={actionsType.MODAL.TERMS_AND_CONDITIONS_CLOSE} keyEScapeBlock={modalTermsConditionBlock} >
            <TermsAndConditions close={()=> PubSub.dispatch(actionsType.MODAL.TERMS_AND_CONDITIONS_CLOSE)}/>
        </Modal>
    )
}

export default ModalTermsConditions;